import { initSentry as initSharedSentry } from '@reveni-io/easy-peasy/sentry'

export const initSentry = () => {
  if (import.meta.env.VITE_SENTRY_ENVIRONMENT) {
    initSharedSentry({
      dsn: import.meta.env.VITE_SENTRY_URL,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
      release: VERSION,
      tracesSampleRate: 1,
    })
  }
}

export const saveLocalStorage = (key, value) => {
  try {
    localStorage[key] = JSON.stringify(value)
    // eslint-disable-next-line
  } catch {} //without catch because is to handle errors if the user is in iframe and incognito mode active.
}

export const getLocalStorage = key => {
  try {
    if (localStorage[key]) return JSON.parse(localStorage[key])
    // eslint-disable-next-line
  } catch {} //without catch because is to handle errors if the user is in iframe and incognito mode active.
}

export const getTheme = (theme, portalTheme) => {
  if (portalTheme) {
    Object.assign(theme, {
      colors: {
        ...theme.colors,
        primary: {
          tone50: portalTheme.primary_brand_color || theme.colors.primary.tone50,
          tone100: portalTheme.primary_brand_color || theme.colors.primary.tone100,
          tone300: theme.colors.primary.tone300,
          tone500: portalTheme.primary_brand_color || theme.colors.primary.tone500,
          tone700: portalTheme.primary_brand_color || theme.colors.primary.tone700,
          tone900: portalTheme.primary_brand_color || theme.colors.primary.tone900,
        },
      },
      title: {
        primary: portalTheme.primary_brand_color || theme.title.primary,
      },
      button: {
        ...theme.button,
        primary: {
          color: portalTheme.button_text_color || theme.button.primary.color,
          backgroundColor: portalTheme.button_background_color || theme.button.primary.backgroundColor,
          borderColor: portalTheme.button_border_color || theme.button.primary.borderColor,
          hover: {
            color: portalTheme.button_text_hover_color || theme.button.primary.hover.color,
            backgroundColor: portalTheme.button_background_hover_color || theme.button.primary.hover.backgroundColor,
            borderColor: portalTheme.button_border_hover_color || theme.button.primary.hover.borderColor,
          },
          disabled: {
            color: portalTheme.button_text_disabled_color || theme.button.primary.disabled.color,
            backgroundColor:
              portalTheme.button_background_disabled_color || theme.button.primary.disabled.backgroundColor,
            borderColor: portalTheme.button_border_disabled_color || theme.button.primary.disabled.borderColor,
          },
        },
        outlined: {
          ...theme.button.outlined,
          color: portalTheme.button_border_color || theme.button.outlined.color,
          borderColor: portalTheme.button_border_color || theme.button.outlined.borderColor,
          hover: {
            color: portalTheme.button_text_hover_color || theme.button.outlined.hover.color,
            backgroundColor: portalTheme.button_background_hover_color || theme.button.outlined.hover.backgroundColor,
            borderColor: portalTheme.button_border_hover_color || theme.button.outlined.hover.borderColor,
          },
          disabled: {
            color: portalTheme.button_text_disabled_color || theme.button.outlined.disabled.color,
            backgroundColor:
              portalTheme.button_background_disabled_color || theme.button.outlined.disabled.backgroundColor,
            borderColor: portalTheme.button_border_disabled_color || theme.button.outlined.disabled.borderColor,
          },
        },
        text: {
          ...theme.button.text,
          color: portalTheme.button_simple_text_color || theme.button.text.color,
          hover: {
            ...theme.button.text.hover,
            color: portalTheme.button_simple_text_hover_color || theme.button.text.hover.color,
          },
          disabled: {
            ...theme.button.text.disabled,
            color: portalTheme.button_simple_text_disabled_color || theme.button.text.disabled.color,
          },
        },
      },
      link: {
        color: portalTheme.link_color || theme.link.color,
        hover: portalTheme.link_hover_color || theme.link.hover,
      },
      splitButton: {
        ...theme.splitButton,
        backgroundColor: portalTheme.split_button_background_color || theme.splitButton.backgroundColor,
        borderColor: portalTheme.split_button_border_color || theme.splitButton.borderColor,
        color: portalTheme.split_button_text_color || theme.splitButton.color,
        iconColor: portalTheme.split_button_icon_color || theme.splitButton.iconColor,
        hover: {
          backgroundColor: portalTheme.split_button_background_hover_color || theme.splitButton.hover.backgroundColor,
          borderColor: portalTheme.split_button_border_hover_color || theme.splitButton.hover.borderColor,
          color: portalTheme.split_button_text_hover_color || theme.splitButton.hover.color,
          iconColor: portalTheme.split_button_icon_hover_color || theme.splitButton.hover.iconColor,
        },
        disabled: {
          backgroundColor:
            portalTheme.split_button_background_disabled_color || theme.splitButton.disabled.backgroundColor,
          borderColor: portalTheme.split_button_border_disabled_color || theme.splitButton.disabled.borderColor,
          color: portalTheme.split_button_text_disabled_color || theme.splitButton.disabled.color,
          iconColor: portalTheme.split_button_icon_disabled_color || theme.splitButton.disabled.iconColor,
        },
        selected: {
          backgroundColor:
            portalTheme.split_button_background_selected_color || theme.splitButton.selected.backgroundColor,
          borderColor: portalTheme.split_button_border_selected_color || theme.splitButton.selected.borderColor,
          color: portalTheme.split_button_text_selected_color || theme.splitButton.selected.color,
          iconColor: portalTheme.split_button_icon_selected_color || theme.splitButton.selected.iconColor,
        },
      },
      variantButton: {
        ...theme.variantButton,
        color: portalTheme.variant_text_color || theme.variantButton.color,
        backgroundColor: portalTheme.variant_background_color || theme.variantButton.backgroundColor,
        borderColor: portalTheme.variant_border_color || theme.variantButton.borderColor,
        hover: {
          color: portalTheme.variant_text_hover_color || theme.variantButton.hover.color,
          backgroundColor: portalTheme.variant_background_hover_color || theme.variantButton.hover.backgroundColor,
          borderColor: portalTheme.variant_border_hover_color || theme.variantButton.hover.borderColor,
        },
        selected: {
          color: portalTheme.variant_text_selected_color || theme.variantButton.selected.color,
          backgroundColor:
            portalTheme.variant_background_selected_color || theme.variantButton.selected.backgroundColor,
          borderColor: portalTheme.variant_border_selected_color || theme.variantButton.selected.borderColor,
        },
        disabled: {
          color: portalTheme.variant_text_disabled_color || theme.variantButton.disabled.color,
          backgroundColor:
            portalTheme.variant_background_disabled_color || theme.variantButton.disabled.backgroundColor,
          borderColor: portalTheme.variant_border_disabled_color || theme.variantButton.disabled.borderColor,
        },
      },
    })
  }

  return theme
}
